import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  imports: [RouterModule],
  selector: 'onegate-root',
  template: `<router-outlet />`,
  styleUrl: './app.component.scss',
})
export class AppComponent {}
